
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { IApplicationState } from "@/store/applications/types";
import { requiredIf } from "vuelidate/lib/validators";
import { ADDRESS_LOOKUP, emptyAddress } from "@/store/addressLookup";
import { IAddressLookupResponse } from "@/store/addressLookup/types";

const { mapGetters, mapState } = createNamespacedHelpers(
  APPLICATION.NAME_SPACE
);

export default Vue.extend({
  data() {
    return {
      emptyAddress
    };
  },
  watch: {
    "$v.$invalid": "setValidity"
  },
  computed: {
    deliveryAddressLookupResponse(): IAddressLookupResponse {
      return this.$store.state.addressLookup.responses.delivery as any;
    },
    deliveryAddressLookupInProgress(): boolean {
      return this.$store.state.addressLookup.progress.delivery.inProgress;
    },
    deliveryAddress: {
      get(): any {
        const deliveryAddress =
          store.state.application.applicationData &&
          store.state.application.applicationData.finalDetails &&
          store.state.application.applicationData.finalDetails.deliveryAddress;

        if (deliveryAddress && deliveryAddress.fullAddress) {
          return deliveryAddress;
        }
        return this.deliveryAddressText || emptyAddress;
      },
      set(value: string) {
        // if the value is a string it's a manual address
        const isManualAddress = typeof value === "string";
        const newValue = isManualAddress ? emptyAddress : value;
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_DELIVERY_ADDRESS),
          newValue
        );

        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_HAS_MANUAL_DELIVERY_ADDRESS),
          isManualAddress
        );
      }
    },
    deliveryAddressText: {
      get(): string {
        return (
          (store.state.application.applicationData &&
            store.state.application.applicationData.finalDetails &&
            store.state.application.applicationData.finalDetails
              .deliveryAddressText) ||
          ""
        );
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_DELIVERY_ADDRESS_TEXT),
          value
        );
      }
    },
    hasManualDeliveryAddress: {
      get(): boolean {
        return (
          (store.state.application.applicationData &&
            store.state.application.applicationData.finalDetails &&
            store.state.application.applicationData.finalDetails
              .hasManualDeliveryAddress) ||
          false
        );
      },
      set(value: boolean) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_HAS_MANUAL_DELIVERY_ADDRESS),
          value
        );
      }
    },
    ...mapState({
      contactNumber: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.finalDetails &&
        state.applicationData.finalDetails.contactNumber
    }),
    ...mapGetters([APPLICATION.GETTERS.IS_EDITABLE])
  },
  methods: {
    setValidity() {
      this.$emit("isvalid", "delivery", !(this as any).$v.$invalid);
    },
    onDeliveryAddressSearch(address: string) {
      this.$store.dispatch(
        ADDRESS_LOOKUP.NS(ADDRESS_LOOKUP.ACTIONS.ADDRESS_LOOKUP_BY_KEY),
        {
          key: "delivery",
          address
        }
      );
    },
    onChangeDeliveryAddressText(value: string) {
      if (value) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_DELIVERY_ADDRESS_TEXT),
          value
        );
      }
    },
    onChangeHasManualDeliveryAddress() {
      this.$store.commit(
        APPLICATION.NS(APPLICATION.MUTATIONS.SET_HAS_MANUAL_DELIVERY_ADDRESS),
        true
      );

      // reset the delivery address object to blank state
      // TODO: figure out that this should actually do
      this.$store.commit(
        APPLICATION.NS(APPLICATION.MUTATIONS.SET_DELIVERY_ADDRESS),
        emptyAddress
      );
    }
  },
  validations: {
    deliveryAddressText: {
      required: requiredIf(vm => vm.hasManualDeliveryAddress && vm.isEditable)
    }
  }
});
